import type { Control } from '@/types/concept';

export function hasValidControlFile(control: Control): boolean {
  return !!(
    control.attributes.file &&
    control.attributes.file.url &&
    control.attributes.file.url.trim() !== ''
  );
}

export function isUnusedCustomControl(control: Control): boolean {
  return !control.attributes.is_used_in_renders;
}

export function filterValidControls(controls: Control[]): Control[] {
  return controls.filter((control) => {
    const isValid = hasValidControlFile(control);
    if (!isValid) {
      console.warn('Filtering out invalid control:', {
        id: control.id,
        control_type: control.attributes.control_type,
        file: control.attributes.file,
      });
    }
    return isValid;
  });
}

export function countUnusedControls(controls: Control[]): number {
  return controls.filter(isUnusedCustomControl).length;
}
